/**
 * Supported Countries Configuration -- OFFLINE FALLBACK
 *
 * This list serves as a FALLBACK when the database is unreachable.
 * The primary validation mechanism is validateCountryHasCampaign() in
 * lib/countryDetection.ts, which queries campaign_countries_languages
 * in real time.
 *
 * This list is synchronized periodically with the database but is NOT
 * the source of truth. Adding a new country only requires inserting
 * a row in campaign_countries_languages -- no code change needed.
 *
 * Last synced with database: 2026-04-10
 */

export const SUPPORTED_COUNTRIES: Set<string> = new Set([
  'CI', // Cote d'Ivoire
  'CL', // Chile
  'CM', // Cameroon
  'CO', // Colombia
  'DE', // Germany
  'ES', // Spain
  'ET', // Ethiopia
  'FR', // France
  'GB', // United Kingdom
  'IT', // Italy
  'MX', // Mexico
  'MY', // Malaysia
  'PE', // Peru
  'RO', // Romania
  'SG', // Singapore
  'SN', // Senegal
  'TH', // Thailand
  'US', // United States
  'VN', // Vietnam
]);

export const DEFAULT_FALLBACK_COUNTRY = 'MA';

export function isCountrySupported(countryCode: string): boolean {
  return SUPPORTED_COUNTRIES.has(countryCode.toUpperCase());
}
